import { Line } from "react-chartjs-2";
import GetWfsResponseTimeRequestService from "../../../services/GetWfsResponseTimeRequestService";
import { GetWfsResponseTimeRequest } from "../../../types/WfsLog/GetWfsResponseTimeRequest";
import { ResponseTimes } from "../../../types/WfsLog/ResponseTimes";
import {
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LineElement,
    LinearScale,
    PointElement,
    Title,
    Tooltip,
  } from "chart.js";

interface RequestStatisticsGraphProps {
    responseTimes?:ResponseTimes;
    filterRequest: GetWfsResponseTimeRequest;
    getWfsResponseTimeRequestService: GetWfsResponseTimeRequestService;
}

const RequestStatisticsGraph = ({responseTimes, filterRequest, getWfsResponseTimeRequestService}:RequestStatisticsGraphProps) => {
    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Legend
      );

    return  <div className="flex-grow-1 w-100 d-flex justify-space-between">
    {responseTimes && (
      <Line
        className="mh-100"
        data={{
          labels:
            responseTimes?.timeStamps?.map((x) =>
              getWfsResponseTimeRequestService.getDateLabel(
                x,
                filterRequest
              )
            ) ?? [],
          datasets: [
            {
              label: `Response per ${getWfsResponseTimeRequestService.getGranularityLabel(
                filterRequest.granularity
              )}`,
              data: responseTimes?.values.map((x) => (x ? x : 0)),
              fill: false,
              backgroundColor: "rgb(255, 99, 132)",
              borderColor: "rgba(255, 99, 132, 0.2)",
            },
          ],
        }}
        options={{
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        }}
      />
    )}
  </div>;
};

export default RequestStatisticsGraph;